export enum TicketCardTransactionStatus {
  APPROVED = 2,
  PENDING = 1,
  REFUND = 3,
  CANCEL = 0,
}
